module.exports = __webpack_public_path__ + "img/operation-icon-active.a168985b.svg";